import styled from '@emotion/styled';
import {
  background,
  border,
  color,
  compose,
  display,
  flexbox,
  layout,
  position,
  shadow,
  space,
  typography,
  BackgroundProps,
  BorderProps,
  ColorProps,
  DisplayProps,
  FlexboxProps,
  GridProps,
  LayoutProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system';
import {
  defineWithTheme,
  WithoutCollidingProps,
  CoreBaseProps,
} from '../../theming';
import shouldForwardProp from '@styled-system/should-forward-prop';
interface BaseSpanProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    GridProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingSpanProps = WithoutCollidingProps<BaseSpanProps, 'span'>;
type NonCollidingSpanKeys = keyof NonCollidingSpanProps;

export const Span = styled('span', {
  shouldForwardProp: (prop): prop is NonCollidingSpanKeys =>
    shouldForwardProp(prop as NonCollidingSpanKeys),
})<BaseSpanProps>(
  defineWithTheme('spans'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    shadow,
    space,
    typography
  )
);

export type SpanProps = React.ComponentPropsWithoutRef<typeof Span>;
